import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function GoalGetterIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3581">
      
      <div className="relative w-full h-full bg-gradient-to-br from-teal-100 to-emerald-200 overflow-hidden" data-id="element-3582">
        {/* Background: Target Board */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3583">
          
          {/* Target */}
          <g transform="translate(140, 60)" data-id="element-3584">
            <circle cx="0" cy="0" r="45" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="2" data-id="element-3585" />
            
            <circle cx="0" cy="0" r="30" fill="#EF4444" data-id="element-3586" />
            <circle cx="0" cy="0" r="15" fill="#FFFFFF" data-id="element-3587" />
            <circle cx="0" cy="0" r="5" fill="#EF4444" data-id="element-3588" />

            {/* Arrow stuck in bullseye */}
            {isUnlocked && <g transform="rotate(-45)" data-id="element-3589">
                <path d="M0 0 L-40 0" stroke="#94A3B8" strokeWidth="3" strokeLinecap="round" data-id="element-3590" />
              
                <path d="M-30 -5 L-40 0 L-30 5" fill="#38BDF8" data-id="element-3591" />
              </g>}
          </g>

          {/* Ground */}
          <path d="M0 160 L200 160 L200 200 L0 200 Z" fill="#34D399" opacity="0.5" data-id="element-3592" />
          
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-start pb-[15%] pl-[10%]" data-id="element-3593">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3594">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'happy' : 'thinking'} variant={variant} accessory="medal" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3595" />
            
          </div>
        </div>

        {/* Foreground: Action lines */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3596">
          
            {/* Arrow flight path */}
            <path d="M80 100 Q110 80 135 65" stroke="#94A3B8" strokeWidth="2" strokeDasharray="4 4" opacity="0.5" data-id="element-3597" />
          

            {/* Celebration sparks near target */}
            <path d="M140 10 L140 20 M140 100 L140 110 M90 60 L100 60 M180 60 L190 60" stroke="#FDE047" strokeWidth="3" strokeLinecap="round" data-id="element-3598" />
          
          </svg>}
      </div>
    </DjayIllustrationBase>;
}